export const TYPES = {
  BIGQUERY: 'bigquery',
  SQL: 'sql'
}